import React from "react";
import "./Team.css";
import Member from "../Components/Member";
function Team() {
  return (
    <div className="team">
      <Member id="0" />
      <Member id="1" />
      <Member id="2" />
      <Member id="3" />
      <Member id="4" />
      <Member id="5" />
      <Member id="6" />
      <Member id="7" />
    </div>
  );
}

export default Team;
